import { SupportedLanguages } from "@/enums/internationalization";
import { LangString } from "@/types/api";

/** Languages we materialize into persistent `LangString` maps like banner copy. */
export const BANNER_LANG_CODES: readonly SupportedLanguages[] = [
  SupportedLanguages.English,
  SupportedLanguages.Spanish,
  SupportedLanguages.Japanese,
  SupportedLanguages.Portuguese,
];

type GetResource = (lng: string, ns: string, key: string) => unknown;

/**
 * Build a `LangString` (map of language code → translation) from an i18next
 * resource accessor. English is always present; other languages are included
 * when a translation exists so consumers fall back gracefully.
 */
export function collectLangString(
  getResource: GetResource,
  ns: string,
  key: string,
  languages: readonly SupportedLanguages[] = BANNER_LANG_CODES
): LangString {
  const out: LangString = {};
  for (const lng of languages) {
    const value = getResource(lng, ns, key);
    if (typeof value === "string" && value.length > 0) {
      out[lng] = value;
    }
  }
  return out;
}
